import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import { Text } from 'react-native';
import PropTypes from 'prop-types';
import TextExtraction from './lib/TextExtraction';
export var PATTERNS = {
  url: /(https?:\/\/|www\.)[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&\/=]*[-a-zA-Z0-9@:%_\+~#?&\/=])*/i,
  phone: /[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,7}/,
  email: /\S+@\S+\.\S+/
};
var defaultParseShape = PropTypes.shape(_objectSpread({}, Text.propTypes, {
  type: PropTypes.oneOf(Object.keys(PATTERNS)).isRequired
}));
var customParseShape = PropTypes.shape(_objectSpread({}, Text.propTypes, {
  pattern: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(RegExp)]).isRequired
}));

var ParsedText =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ParsedText, _React$Component);

  function ParsedText() {
    _classCallCheck(this, ParsedText);

    return _possibleConstructorReturn(this, _getPrototypeOf(ParsedText).apply(this, arguments));
  }

  _createClass(ParsedText, [{
    key: "setNativeProps",
    value: function setNativeProps(nativeProps) {
      this._root.setNativeProps(nativeProps);
    }
  }, {
    key: "getPatterns",
    value: function getPatterns() {
      return this.props.parse.map(function (option) {
        var type = option.type,
            patternOption = _objectWithoutProperties(option, ["type"]);

        if (type) {
          if (!PATTERNS[type]) {
            throw new Error("".concat(option.type, " is not a supported type"));
          }

          patternOption.pattern = PATTERNS[type];
        }

        return patternOption;
      });
    }
  }, {
    key: "getParsedText",
    value: function getParsedText() {
      var _this = this;

      if (!this.props.parse) {
        return this.props.children;
      }

      if (typeof this.props.children !== 'string') {
        return this.props.children;
      }

      var textExtraction = new TextExtraction(this.props.children, this.getPatterns());
      return textExtraction.parse().map(function (props, index) {
        return React.createElement(Text, _extends({
          key: "parsedText-".concat(index)
        }, _this.props.childrenProps, props));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this; // Discard custom props before passing remainder to Text


      var _this$props = _objectSpread({}, this.props),
          parse = _this$props.parse,
          childrenProps = _this$props.childrenProps,
          remainder = _objectWithoutProperties(_this$props, ["parse", "childrenProps"]);

      return React.createElement(Text, _extends({
        ref: function ref(_ref) {
          return _this2._root = _ref;
        }
      }, remainder), this.getParsedText());
    }
  }]);

  return ParsedText;
}(React.Component);

_defineProperty(ParsedText, "displayName", 'ParsedText');

_defineProperty(ParsedText, "propTypes", _objectSpread({}, Text.propTypes, {
  parse: PropTypes.arrayOf(PropTypes.oneOfType([defaultParseShape, customParseShape])),
  childrenProps: PropTypes.shape(Text.propTypes)
}));

_defineProperty(ParsedText, "defaultProps", {
  parse: null,
  childrenProps: {}
});

export default ParsedText;